module.exports = __webpack_public_path__ + "static/media/basketball.4ab21cd8.png";